import { RouteRecordRaw } from 'vue-router';

export default (): Array<RouteRecordRaw> => {
    return [
        {
            path: '/village/activities',
            name: 'village_activities',
            component: () => import("./views/activities.vue"),
            meta: {
                hideTopCut: true
            }
        },
        {
            path: '/village/activity/:identifier',
            name: 'village_activity',
            component: () => import("./views/activity.vue"),
            meta: {
                hideTopCut: true
            }
        },
    ];
};